import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router';

import { CollateralDataQualityCheck } from './CollateralDataQualityCheckOverview';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  return (
    <CollateralDataQualityCheck
      organizationId={user.organization.id}
      receivablesRoutePrefix={
        user.userType === 'BORROWER' ? '/receivables' : '/portfolio/receivables'
      }
    />
  );
};

// Exports
export const permissions: PermissionsFn = (context) => {
  if (context.user.organization.slug === 'valleyBank') return 'deny';
  return context.flags.productsCollateralDataMonitoringPermissions;
};
export const Route = () => (
  <PermissionGuard
    permissions={permissions}
    fallback={<Navigate to="/" replace />}
  >
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <Flex
        direction="column"
        padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
      >
        <RouteBase />
      </Flex>
    </RouteErrorBoundary>
  </PermissionGuard>
);
